import { Component, OnInit } from '@angular/core';
import { UserCredentials } from '../../model/user-credentials';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../resources/user/user.service';
import { Router } from '@angular/router';
import { MzToastService } from 'ng2-materialize';
import { SpinnerService } from '../../services/spinner/spinner.service';

@Component({
  selector:    'app-login',
  templateUrl: './login.component.html',
  styleUrls:   [ './login.component.scss' ]
})
export class LoginComponent implements OnInit {

  userForm: FormGroup;

  s: any;

  errorMessageResources = {
    login:    {
      required: 'Podaj login'
    },
    password: {
      required: 'Podaj hasło'
    }
  };

  user: UserCredentials = {
    username: null,
    password: null
  };

  constructor(private formBuilder: FormBuilder,
              private userService: UserService,
              private router: Router,
              private spinner: SpinnerService,
              private toast: MzToastService) {
  }

  ngOnInit() {
    this.buildForm();
  }


  onSubmit() {
    this.s = this.spinner.show('Sprawdzam...');
    this.loginUser();
  }

  private loginUser() {
    this.user = <UserCredentials>{ ...this.userForm.getRawValue() };
    this.userService.login(this.user).subscribe(() => {
      this.router.navigate([ 'dashboard' ]);
    }, (error) => {
      this.s.close();
      this.toast.show('Błąd logowania', 2000, 'error');
    });
  }

  private buildForm() {

    this.userForm = this.formBuilder.group({
      username: [ this.user.username,
                  Validators.compose([ Validators.required ]) ],
      password: [ this.user.password,
                  Validators.compose([ Validators.required ]) ]
    });
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/login/login.component.ts